/**
 * Показники організації для блоку під Hero на головній — ADR-0007.
 *
 * TODO: замінити null на реальні дані СГОСТУ.
 * Поки значення null, у блоці замість числа виводиться прочерк. Якщо заповнених
 * значень менше двох, блок не рендериться взагалі.
 *
 * Вигадувати правдоподібні числа для офіційного сайту не можна: їх процитують.
 */
export const stats = [
  { value: '20+', labelUa: 'років роботи', labelEn: 'years of work' },
  { value: null, labelUa: 'обласних підрозділів', labelEn: 'regional divisions' },
  { value: null, labelUa: 'клубів у реєстрі', labelEn: 'clubs registered' },
  { value: null, labelUa: 'суддів у реєстрі', labelEn: 'judges registered' },
];
